<script lang="ts">
  import {createEventDispatcher} from 'svelte';

  const dispatch = createEventDispatcher();

  export let selectedDate: Date | null;
  export let minDate: Date | null;
  export let maxDate: Date | null;
  export let year: number;

  $: selectedMonth = selectedDate && selectedDate.getMonth();
  $: selectedYear = selectedDate && selectedDate.getFullYear();

  // Returns whether the given month is today or not
  const isToday = (monthIndex: number) => {
    const today = new Date();
    const thisYear = today.getFullYear();
    const thisMonth = today.getMonth();

    const date = new Date(year, monthIndex, 1);
    const givenYear = date.getFullYear();
    const givenMonth = date.getMonth();

    return thisYear === givenYear && thisMonth === givenMonth;
  };

  // Returns whether the given month is selected or not
  $: isSelected = (monthIndex: number) => {
    const date = new Date(year, monthIndex, 1);
    const givenYear = date.getFullYear();
    const givenMonth = date.getMonth();

    return (
      selectedDate && selectedYear === givenYear && selectedMonth === givenMonth
    );
  };

  // Returns whether the given month is disabled or not
  $: isDisabled = (monthIndex: number) => {
    const monthStart = new Date(year, monthIndex, 1);
    const monthEnd = new Date(year, monthIndex + 1, 1, 0, 0, 0, -1);
    const min = minDate;
    const max = maxDate;

    return (min && monthEnd < min) || (max && monthStart > max);
  };
</script>

<style lang="postcss">
  .monthsContainer {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  .monthsContainer > button.today {
    color: var(--ubilabs-calendar-tile-now-color);
  }

  .monthsContainer > button.selected {
    background-color: var(--ubilabs-calendar-tile-has-active-background-color);
  }

  .monthsContainer > button.selected:not([disabled]):hover,
  .monthsContainer > button.selected:not([disabled]):focus-visible {
    background-color: var(
      --ubilabs-calendar-tile-has-active-hover-background-color
    );
  }
</style>

<div class="monthsContainer">
  {#each {length: 12} as _, monthIndex (monthIndex)}
    <button
      class:today={isToday(monthIndex)}
      class:selected={isSelected(monthIndex)}
      disabled={isDisabled(monthIndex)}
      on:click|preventDefault={() => {
        if (!isDisabled(monthIndex)) {
          dispatch('select', monthIndex);
        }
      }}>
      {new Date(year, monthIndex, 1).toLocaleDateString(undefined, {
        month: 'long'
      })}
    </button>
  {/each}
</div>
